import { createApi, createStore } from "effector";
import { persist } from "effector-storage/session";

import { BookingProcessStore, BookingType } from "./types";
import { defaultState } from "./utils";
import { CategorySlugEnum } from "../../shared/types";

export const $bookingProcess = createStore<BookingProcessStore>(defaultState);

persist<BookingProcessStore>({
  store: $bookingProcess,
  key: "booking-v4-booking-process",
  def: defaultState,
});

export const bookingProcessApi = createApi($bookingProcess, {
  setIsBooked: (prevState: BookingProcessStore, isBooked: boolean) => ({
    ...prevState,
    isBooked,
  }),

  setIsBooking: (prevState: BookingProcessStore, isBooking: boolean) => ({
    ...prevState,
    isBooking,
  }),

  setBookingType: (
    prevState: BookingProcessStore,
    bookingType: BookingType,
  ) => ({
    ...prevState,
    bookingType,
  }),

  setEmptyFields: (
    prevState: BookingProcessStore,
    emptyFields: BookingProcessStore["emptyFields"],
  ) => {
    // Compare arrays of objects using JSON.stringify (works for simple objects)
    const isSame =
      JSON.stringify(prevState.emptyFields) === JSON.stringify(emptyFields);

    if (isSame) {
      return prevState;
    }

    return {
      ...prevState,
      emptyFields,
    };
  },

  setSelectedServices: (
    prevState: BookingProcessStore,
    selectedServices: CategorySlugEnum[],
  ) => {
    return {
      ...prevState,
      selectedServices,
    };
  },

  reset: () => ({
    ...defaultState,
  }),
});
